<template>
  <el-card
    v-loading="completedDisputes == null"
    shadow="hover"
    class="box-card"
    body-style="padding: 16px; padding-top: 8px;"
  >
    <div slot="header" class="clearfix">
      <span>Completed Disputes</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="exportDisputes">Export</el-button>
    </div>
    <span v-if="completedDisputes == null" class="center-message">No Disputes</span>
    <div v-else>
      <div
        v-for="dispute in completedDisputes"
        :key="dispute.o_id"
        class="text item"
        @click="showDispute(dispute)"
      >
        <div class="list-tile">
          <span
            class="list-title"
          >{{ getFullName(dispute.attendance_record.user) + ' - ' + dispute.dispute_type.name }}</span>
          <div style="display: flex">
            <span
              class="list-subtext"
              style="margin-right: auto;"
            >{{ dispute.attendance_record.event.date + ' - ' + dispute.attendance_record.event.event_type.name }}</span>
            <span class="list-subtext">
              <i
                v-if="dispute.filename != null"
                style="vertical-align: middle; font-size: 14px;"
                class="material-icons"
              >attach_file</i>
            </span>
          </div>
        </div>
      </div>
    </div>
        <el-pagination
          style="line-height: 12px; margin-top: 16px;"
          background
          layout="prev, pager, next"
          :page-count="lastPage"
          @current-change="changePage"
          :current-page="page"
          @prev-click="changePage"
          @next-click="changePage"
        />
    <nxs-dispute-modal ref="disputeModal" v-model="tempDispute" />
    <el-dialog
      title="Exporting Disputes"
      :visible.sync="exporting"
      width="80%"
    >
    <el-progress :text-inside="true" :stroke-width="26" :percentage="dPercentage"></el-progress>
    </el-dialog>
  </el-card>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {completedDisputes: null, tempDispute: null, page: 1, lastPage: 1, pageLoading: true, exporting: false, dPercentage: 0};
    },
    created() {
        if (!this.$store.getters.hasPermission(["All", "Disputes"]))
            this.$router.push("/admin");
    },
    computed: {...mapFields(["user", "users", "permissions", "selectedTerms"])},
    mounted() {
        if (this.dispute_types == null) this.$store.dispatch("pullDisputeTypes");
        if (this.levels == null) this.$store.dispatch("pullLevels");
        this.getCompletedDisputes();
    },
    watch: {
        selectedTerms(){
            this.page = 1;
            this.getCompletedDisputes();
        }
    },
    methods: {
        showDispute(dispute) {
            this.tempDispute = dispute;
            this.$refs.disputeModal.open();
        },
        changePage(newPage) {
            this.$set(this, 'pageLoading', true);
            this.page = newPage;
            this.getCompletedDisputes();
        },
        getCompletedDisputes() {
            this.axios
                .get("/api/v1/attendance/disputes", {
                    params: {
                        terms: this.selectedTerms,
                        status: 'completed',
                        page: this.page
                    },
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.completedDisputes = response.data.data;
                    this.lastPage = response.data.last_page;
                    this.pageLoading = false;
                })
                .catch((err) => {
                    this.pageLoading = false;
                    console.error(err);
                    this.$message({
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },
        exportDisputes() {
            this.exporting = true;
            this.axios({
                url: "/api/v1/attendance/disputes/export",
                params: {terms: this.selectedTerms},
                method: "GET",
                responseType: "blob",
                onDownloadProgress: (progressEvent) => {
                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength !== null) {
                        this.dPercentage = Math.round(progressEvent.loaded * 100 / totalLength);
                    }
                }
            }).then((response) => {
                if (navigator.msSaveBlob) {
                    var blob = new Blob([response.data], {type: "application/zip;charset=utf-8;"});
                    navigator.msSaveBlob(blob, "disputes.zip");
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "disputes.zip");
                    document.body.appendChild(link);
                    link.click();
                }
                this.exporting = false;
            });
        }
    }
};
</script>
